import styled from "styled-components";
import { Modal as BaseModal } from "antd";

export const Container = styled.div`
  display: initial;

  .title {
    color: ${props => props.theme.colors.secondary};
    font-size: 28px;
    font-weight: 700;
    line-height: 36px;
    align-items: center;
    letter-spacing: 1px;
  }
  width: 100%;
  position: relative;
`;

export const ModalTitle = styled.div`
  color: ${props => props.theme.colors.secondary};
  font-size: 28px;
  font-weight: 700;
  line-height: 36px;
  align-items: center;
  justify-content: center;
  display: flex;
  letter-spacing: 1px;

  margin-bottom: 16px;
`;

export const ModalChildren = styled.div`
  color: ${props => props.theme.colors.secondary};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  align-items: center;
`;

export const Modal = styled(BaseModal)`
  .ant-modal-body {
    padding: 48px 32px 32px 32px;
  }

  .ant-modal-content {
    width: 100%;
    border-radius: 16px;
  }

  .ant-modal-header {
    padding: 30px;
    border-bottom: none !important;
    
  }

  .anticon svg {
    color: ${props => props.theme.colors.secondary};
  }

  .ant-modal-footer {
    border-top: none !important;
    padding: 0 32px 48px 32px;
  }
`;